import React from 'react'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

import { city, isForeignAddress, postalCode, state, street } from '@sputnik/schema/creditApplication/address'
import { baseAddress } from '@sputnik/schema/creditApplication/address/addressSchema'

export const countryCode = yup.string()

export const address = baseAddress.shape({
  street: street.nullable(),
})

export const requiredAddress = yup
  .object()
  .concat(baseAddress)
  .shape({
    isForeignAddress: isForeignAddress,
    street: street.required(() => (
      <FormattedMessage
        defaultMessage='Street is required.'
        id='sputnik.requiredAddressSchema__VmfBtu'
      />
    )),
    streetAdditional: street.nullable(),
    city: city.required(() => (
      <FormattedMessage
        defaultMessage='City is required.'
        id='sputnik.requiredAddressSchema__W435jR'
      />
    )),
    state: state.required(() => (
      <FormattedMessage
        defaultMessage='State is required.'
        id='sputnik.requiredAddressSchema__Lmlys/'
      />
    )),
    postalCode: postalCode.required(() => (
      <FormattedMessage
        defaultMessage='ZIP code is required.'
        id='sputnik.requiredAddressSchema__XN8b5q'
      />
    )),
    countryCode: countryCode.when('isForeignAddress', {
      is: 'YES',
      then: (schema) =>
        schema.required(() => (
          <FormattedMessage
            defaultMessage='Country is required.'
            id='sputnik.requiredAddressSchema__1/Motd'
          />
        )),
      otherwise: (schema) => schema.default('US').required(),
    }),
  })

export type RequiredAddress = yup.InferType<typeof requiredAddress>
